/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbClasseHoraireCoherenceSemestreGridDto } from './FcbClasseHoraireCoherenceSemestreGridDto';
import {
    FcbClasseHoraireCoherenceSemestreGridDtoFromJSON,
    FcbClasseHoraireCoherenceSemestreGridDtoFromJSONTyped,
    FcbClasseHoraireCoherenceSemestreGridDtoToJSON,
} from './FcbClasseHoraireCoherenceSemestreGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbClasseHoraireCoherenceSemestreGridDtoPaginatedResults
 */
export interface FcbClasseHoraireCoherenceSemestreGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbClasseHoraireCoherenceSemestreGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbClasseHoraireCoherenceSemestreGridDto>}
     * @memberof FcbClasseHoraireCoherenceSemestreGridDtoPaginatedResults
     */
    results?: Array<FcbClasseHoraireCoherenceSemestreGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbClasseHoraireCoherenceSemestreGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbClasseHoraireCoherenceSemestreGridDtoPaginatedResults interface.
 */
export function instanceOfFcbClasseHoraireCoherenceSemestreGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbClasseHoraireCoherenceSemestreGridDtoPaginatedResultsFromJSON(json: any): FcbClasseHoraireCoherenceSemestreGridDtoPaginatedResults {
    return FcbClasseHoraireCoherenceSemestreGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbClasseHoraireCoherenceSemestreGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbClasseHoraireCoherenceSemestreGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbClasseHoraireCoherenceSemestreGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbClasseHoraireCoherenceSemestreGridDtoPaginatedResultsToJSON(value?: FcbClasseHoraireCoherenceSemestreGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbClasseHoraireCoherenceSemestreGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

